import { FormControl, Grid, InputLabel, NativeSelect } from '@material-ui/core';
import * as React from 'react';
import FormInputField from './FormInputField';

export interface DropDownOption {
  value: string;
  label: string;
}

interface Props {
  readOnly?: boolean;
  value?: string;
  optionList: Array<string | DropDownOption>;
  onChange: (value: string) => void;
  fieldName: string;
  required?: boolean;
  fullWidth?: boolean;
}

const toOption = (option: string | DropDownOption): DropDownOption =>
  typeof option === 'string' ? { value: option, label: option } : option;

const DropDownSelectField = ({ readOnly, value, onChange, optionList, fieldName, required = true, fullWidth }: Props) => {
  const options = optionList.map(toOption);
  const selected = options.find(option => option.value === value);
  if (readOnly) {
    return (
      <FormInputField
        label={fieldName}
        required={required}
        value={selected ? selected.label : value || ''}
        InputProps={{ readOnly: true, disableUnderline: true }}
        fullWidth={fullWidth}
      />
    )
  }
  return (
    <Grid item md={fullWidth ? 12 : 6} xs={12}>
      <FormControl required={required} fullWidth>
        <InputLabel shrink>{fieldName}</InputLabel>
        <NativeSelect
          value={value || ''}
          onChange={event => onChange(event.target.value)}
          inputProps={{ title: selected ? selected.label : '' }}
        >
          <option value="" />
          {options.map(option => (
            <option key={option.value} value={option.value} title={option.label}>
              {option.label}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    </Grid>
  );
};

export default React.memo(DropDownSelectField);
